export const getAvailableColumns = (element, inspection_category_types, type = 'default') => {
  const columns = [
    { id: 'no', name: 'Weld No', type: 'default' },
    { id: 'weld_type', name: 'Weld Type', type: 'default' },
    { id: 'length', name: 'Length [mm]', type: 'default' },
    { id: 'diameter_1', name: 'Diameter 1 [mm]', type: 'default' },
    { id: 'thickness_1', name: 'Thickness 1 [mm]', type: 'default' },
    { id: 'diameter_2', name: 'Diameter 2 [mm]', type: 'default' },
    { id: 'thickness_2', name: 'Thickness 2 [mm]', type: 'default' },
    { id: 'material_1', name: 'Material 1', type: 'default' },
    { id: 'material_2', name: 'Material 2', type: 'default' }
  ]

  if (element && element.extra_columns) {
    try {
      const extraColumns = JSON.parse(element.extra_columns)
      Object.keys(extraColumns).forEach(key => {
        columns.push({ id: key, name: extraColumns[key], type: 'extra_column' })
      })
    } catch (e) {
      console.error('Error parsing extra_columns:', e)
    }
  }

  columns.push(
    { id: 'inspection_category', name: 'Inspection category', type: 'default' },
    { id: 'wps', name: 'WPS', type: 'default' },
    { id: 'welding_progress', name: 'Welding [%]', type: 'none' },
    { id: 'welder', name: 'Welder', type: 'default' },
    { id: 'last_welding_date', name: 'Last welding date', type: 'default' },
    { id: 'welding_wps', name: 'Welding WPS', type: 'default' },
    { id: 'welding_consumables', name: 'Welding Consumables', type: 'default' },

  )

  if (element && element.inspection_categories && inspection_category_types) {
    const projectInspections = []
    element.inspection_categories.forEach(inspCat => {
      inspCat.inspections.forEach(insp => {
        if (!projectInspections.includes(insp.type_id)) {
          projectInspections.push(insp.type_id)
        }
      })
    })

    inspection_category_types.forEach(inspType => {
      if (projectInspections.includes(Number(inspType.id))) {
        columns.push({ id: `$inspections_${inspType.id}`, name: inspType.name, type: 'inspection_category' })
      }
    })
  }

  columns.push({ id: 'status', name: 'Status', type: 'none' })

  return columns
}



// WEBPACK FOOTER //
// ./src/utils/columnUtils.js